export default "__VITE_ASSET__BoqJoGnZ__"